import { SALESFORCE_ENABLED, CAMPAIGNS_ENABLED } from '../constants';

export function getPathPrefix() {
  return SALESFORCE_ENABLED || CAMPAIGNS_ENABLED ? '/campaigns/:campaignId/projects/:projectId' : '/projects/:projectId';
}

export function getUrlPrefix(campaignId, projectId) {
  return campaignId ? `/campaigns/${campaignId}/projects/${projectId}` : `/projects/${projectId}`;
}
